<template>
  <div class="master-filter app-filter hideSmartphone">
    <div class="app-filter-label">{{ label }}</div>
    <div class="app-filter-select">
      <b-dropdown
        ref="dropdown-filters"
        variant="link"
        toggle-class="app-filter-toggle"
        menu-class="app-filter-menu"
        no-caret
      >
        <template #button-content>
          <div class="app-filter-trigger">
            <span>{{ inspectionsFor.active.name }}</span>
            <svg width="14" height="14" viewBox="0 0 20 20" fill="none" aria-hidden="true">
              <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </template>
        <b-dropdown-item
          class="app-filter-item"
          link-class="app-filter-option-link"
          :class="{'active-filter': inspectionsFor.active.value === item.value}"
          href="#"
          v-for="(item, key) in inspectionsFor.inDropdown"
          :key="key"
          @click="filterPeriod(item)"
        >
          <div class="app-filter-option">
            <span class="app-filter-option-label">{{ item.name }}</span>
            <span v-if="inspectionsFor.active.value === item.value" class="app-filter-check">✓</span>
          </div>
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterByPeriod",
  props: {
    label: String,
  },
  created() {
    this.setDefaultValue();
  },
  methods: {
    setDefaultValue() {
      this.inspectionsFor.active = this.inspectionsFor.defaultValue;
    },
    getFirstDayOfTheMonth () {
      const date = new Date();
      const firstDayCurrentMonth = new Date(
        date.getFullYear(),
        date.getMonth(),
        1
      );
      return firstDayCurrentMonth.toLocaleDateString("sk-SK");
    },
    getFirstDayOfTheSecondLastMonth () {
      const date = new Date();
      const firstDayCurrentMonth = new Date(
        date.getFullYear(),
        date.getMonth() - 2,
        1
      );
      return firstDayCurrentMonth.toLocaleDateString("sk-SK");
    },
    getFirstDayOfTheLastMonth () {
      const date = new Date();
      const firstDayCurrentMonth = new Date(
        date.getFullYear(),
        date.getMonth() - 1,
        1
      );
      return firstDayCurrentMonth.toLocaleDateString("sk-SK");
    },
    getLastDayOfTheLastMonth () {
      const date = new Date();
      const firstDayCurrentMonth = new Date(
        date.getFullYear(),
        date.getMonth(),
        0
      );
      return firstDayCurrentMonth.toLocaleDateString("sk-SK");
    },
    getMondayOfWeek (type) {
      const today = new Date();
      let first = null;
      if (type === "current") {
        first = today.getDate() - today.getDay() + 1;
      } else {
        first = today.getDate() - today.getDay() + 1 - 7;
      }

      const monday = new Date(today.setDate(first));
      return monday.toLocaleDateString("sk-SK");
    },
    getDateOfDatePriorToToday (days) {
      const today = new Date();
      const priorDate = new Date(new Date().setDate(today.getDate() - days));
      return priorDate.toLocaleDateString("sk-SK");
    },
    filterPeriod (item) {
      this.inspectionsFor.active = item;
      let gte = null;
      let stgte = null;
      let lt = null;
      let stlt = null;
      switch (item.value) {
        case "thisWeek":
          gte = this.getMondayOfWeek("current");
          stgte = this.getMondayOfWeek("previous");
          stlt = this.getMondayOfWeek("current");
          break;
        case "lastSevenDays":
          gte = this.getDateOfDatePriorToToday(7);
          stgte = this.getDateOfDatePriorToToday(14);
          stlt = this.getDateOfDatePriorToToday(7);
          break;
        case "lastFifteenDays":
          gte = this.getDateOfDatePriorToToday(15);
          stgte = this.getDateOfDatePriorToToday(30);
          stlt = this.getDateOfDatePriorToToday(15);
          break;
        case "thisMonth":
          gte = this.getFirstDayOfTheMonth();
          stgte = this.getFirstDayOfTheLastMonth();
          stlt = this.getLastDayOfTheLastMonth();
          break;
        case "lastThirtyDays":
          gte = this.getDateOfDatePriorToToday(30);
          stgte = this.getDateOfDatePriorToToday(60);
          stlt = this.getDateOfDatePriorToToday(30);
          break;
        case "lastMonth":
          gte = this.getFirstDayOfTheLastMonth();
          stlt = this.getFirstDayOfTheLastMonth();
          lt = this.getLastDayOfTheLastMonth();
          stgte = this.getFirstDayOfTheSecondLastMonth();
          break;
        case "all":
          gte = null;
          stlt = null;
          lt = null;
          stgte = null;
          break;
        default:
          gte = null;
          stlt = null;
          lt = null;
          stgte = null;
          break;
      }
      this.$emit("period-filter-change", {gte: gte, lt: lt});
      this.$emit("period-statistic-change", {gte: stgte, lt: stlt});
      this.$emit("period-filter-change-1", {gte: gte, lt: lt, stgte: stgte, stlt: stlt});
    },
  },
  data: () => ({
    inspectionsFor: {
      defaultValue: {name: "Všetko", value: "all"},
      active: null,
      inDropdown: [
        {name: "Všetko", value: "all"},
        {name: "Tento týždeň", value: "thisWeek"},
        {name: "Posledných 7 dní", value: "lastSevenDays"},
        {name: "Posledných 15 dní", value: "lastFifteenDays"},
        {name: "Tento mesiac", value: "thisMonth"},
        {name: "Posledných 30 dní", value: "lastThirtyDays"},
        {name: "Predchádzajúci mesiac", value: "lastMonth"},
      ],
    },
  }),
}
</script>

<style lang="scss" scoped></style>
